<ng-container>
  <div *ngIf="isMode == 'create'" style="position: relative">
    <textarea type="text" #memoTextArea [rows]="maxRows" [maxLength]="maxLength" [(ngModel)]="inputNote" (input)="checkTextarea($event)" placeholder="Enter notes here"></textarea>
    <div class="textarea-text-length" *ngIf="!isShowErr">{{ noteLength }} / {{ maxLength }}</div>
    <div class="textarea-err" *ngIf="isShowErr">Text input limit reached. Please shorten your text.</div>
  </div>
  <pre *ngIf="isMode != 'create'">{{ summaryNote }}</pre>
</ng-container>